/**
 * Capture et persistance des identifiants de clic publicitaire.
 *
 * Le tunnel de location quitte le site (redirection GreenLeaze) : sans ces
 * identifiants transmis au partenaire, aucune conversion ne peut être
 * réattribuée à la campagne qui l'a générée. On les capte à l'atterrissage,
 * on les garde 90 jours (fenêtre d'attribution Google Ads), et on les rejoue
 * au moment de la redirection.
 */
(function() {
  var STORAGE_KEY = 'ltm_ad_attribution';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;

  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);

      if (!raw) {
        return null;
      }

      var stored = JSON.parse(raw);

      if (!stored || !stored.captured_at) {
        return null;
      }

      if (Date.now() - stored.captured_at > MAX_AGE_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return stored;
    } catch (error) {
      return null;
    }
  }

  function capture() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var hasClickId = false;

    CLICK_IDS.concat(UTM_KEYS).forEach(function(key) {
      var value = params.get(key);

      if (!value) {
        return;
      }

      found[key] = value;

      if (CLICK_IDS.indexOf(key) !== -1) {
        hasClickId = true;
      }
    });

    /* On n'écrase l'attribution existante que si un nouveau clic payant arrive :
       une visite directe ultérieure ne doit pas effacer la source d'origine. */
    if (!hasClickId && Object.keys(found).length === 0) {
      return read();
    }

    var existing = read();

    if (existing && !hasClickId) {
      return existing;
    }

    found.captured_at = Date.now();
    found.landing_page = window.location.pathname;

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    } catch (error) {
      /* navigation privée : on garde la valeur en mémoire pour la session */
    }

    return found;
  }

  var attribution = capture();

  /* Le fbc/fbp de Meta se déduit du fbclid : la CAPI en a besoin pour
     rapprocher l'événement serveur du clic. */
  function facebookClickId(data) {
    if (!data || !data.fbclid) {
      return null;
    }

    var stamp = data.captured_at || Date.now();

    return 'fb.1.' + stamp + '.' + data.fbclid;
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));

    return match ? decodeURIComponent(match[2]) : null;
  }

  window.LTMTracking = {
    get: function() {
      var data = attribution || read();

      if (!data) {
        return null;
      }

      return Object.assign({}, data, {
        fbc: facebookClickId(data),
        fbp: readCookie('_fbp'),
        ga_client_id: readCookie('_ga'),
        page_url: window.location.href,
      });
    },

    /* Identifiant partagé entre l'événement navigateur et l'éventuel envoi
       serveur : sans lui, Meta compte la conversion deux fois. */
    newEventId: function() {
      if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
      }

      return 'ltm-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
    },

    publish: function(eventName, payload) {
      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish(eventName, payload || {});
        }
      } catch (error) {
        /* le tracking ne doit jamais casser le parcours d'achat */
      }
    },
  };
})();
